import React from "react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { CheckCircle } from "lucide-react";
const TherapistApproval = () => {
  return <div className="min-h-screen bg-gradient-to-b from-[#E8F0F8] to-white flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }}>
          <Card className="backdrop-blur-sm bg-white">
            <CardHeader className="text-center">
              <div className="mx-auto mb-4 bg-[#E8F0F8] p-3 rounded-full">
                <CheckCircle className="h-12 w-12 text-[#333B44]" />
              </div>
              <CardTitle className="text-2xl">Registration Received</CardTitle>
              <CardDescription>
                Thank you for registering as a therapist
              </CardDescription>
            </CardHeader>
            <CardContent className="space-y-6">
              <div className="text-center space-y-4">
                <p className="text-[#333B44]">
                  Your registration will now be reviewed by our team. Therapist accounts require approval before they can be activated.
                </p>
                <p className="text-[#333B44]">You'll receive an email shortly with some next steps.

 Once we have reviewed your responses, we’ll let you know your approval status. If approved, you will have 10 days to try out the system for free.

After that, a subscription will be required to continue using Clou.
              </p>
              </div>

              <div className="pt-4">
                <Link to="https://www.clamalo.com/for-therapists">
                  <Button className="w-full bg-[#333B44] hover:bg-[#333B44]/90">
                    Return to Home
                  </Button>
                </Link>
              </div>
            </CardContent>
          </Card>
        </motion.div>
      </div>
    </div>;
};
export default TherapistApproval;